import * as React from 'react';
import LineChart from '../../../views/charts/LineChart';
import {AutoSizer} from 'react-virtualized';
import {DateRange} from '../../../stores/TimeIntervalStore';
import {observer} from 'mobx-react';
import {stylesheet} from 'typestyle';
import {spinner} from '../../../styles/style';
import {Channel} from '../../../types/Channel';
import {MergedBuildingBlockInstructions} from '../../types/Report';
import LineChartPreviewStore, {LineChartPreviewState} from '../../stores/LineChartPreviewStore';
import {BlueColor} from '../../../styles/colors';

export interface LineChartPreviewInBlockProps {
    targetCurrency?: string;
    mergedBuildingBlockInstructions: MergedBuildingBlockInstructions;
    dateRange: DateRange;
    compareDateRange?: DateRange;
    getFullChannelForChannelName: (channelName: string) => Channel;
}

@observer
export default class LineChartPreview extends React.Component<LineChartPreviewInBlockProps> {
    private lineChartPreviewStore: LineChartPreviewState = new LineChartPreviewStore(this.props.getFullChannelForChannelName);

    public componentDidMount() {
        this.lineChartPreviewStore.checkForChartUpdate(this.props);
    }

    public componentWillReceiveProps(newProps: LineChartPreviewInBlockProps) {
        this.lineChartPreviewStore.checkForChartUpdate(newProps, this.props);
    }

    public render() {
        if (this.lineChartPreviewStore.dataLoading) {
            return (
                <div className={lineChartCss.loadingSpinnerContainer}>
                    <div style={{position: 'relative', width: 100, height: 100, borderRadius: 2}}>
                        <div className={spinner(80, 'transparent', BlueColor)} />
                    </div>
                </div>
            );
        }

        return (
            <AutoSizer>
                {(p) => (
                    <LineChart
                        disableTooltip={true}
                        disableClickableDot={true}
                        data={this.lineChartPreviewStore.data}
                        width={p.width}
                        height={p.height}
                        mainDateRange={this.props.dateRange}
                        compareDateRange={this.props.compareDateRange || this.props.dateRange}
                        visibleAttribute={this.lineChartPreviewStore.generateVisibleAttributes(this.props)}
                        animation={false}
                    />
                )}
            </AutoSizer>
        );
    }
}

const lineChartCss = stylesheet({
    loadingSpinnerContainer: {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PaperSheetBlocks/LineChartPreview.tsx